// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "css/" + {"49":"join","177":"home","443":"about"}[chunkId] + "." + {"49":"5face8e0","177":"a6bc7706","443":"30d7b0b6"}[chunkId] + ".css";
};